import { commonTypography } from '../config/theme/shared/typography';

function pxToRem(unitInPx: number): string {
  return `${unitInPx / commonTypography.htmlFontSize}rem`;
}

function remToPx(unitInRem: number): string {
  return `${unitInRem * commonTypography.htmlFontSize}px`;
}

export const layout = {
  pxToRem,
  remToPx,
};
